import { isMockMode } from '@src/config/api';
import store from '@src/store/index';
import { updateRefreshPdf } from '@src/store/slices/ui';
import { useEffect, useRef } from 'react';

/**
 * フォーカスモード切り替え時のPDF同期を管理するカスタムフック
 *
 * @param isFocusMode - フォーカスモード状態
 * @param isRirekishoMode - 履歴書モードかどうか
 * @param token - PDFアクセストークン
 * @param resetCanvas - キャンバスリセット関数
 */
export const useFocusModeSync = (
  isFocusMode: boolean,
  isRirekishoMode: boolean,
  token: string,
  resetCanvas: () => void
) => {
  const prevFocusModeRef = useRef<boolean>(isFocusMode);

  /**
   * フォーカスモードからの切り替えを検知してPDF再生成をトリガー
   */
  useEffect(() => {
    const wasFocusMode = prevFocusModeRef.current;
    const isNowFocusMode = isFocusMode;

    if (wasFocusMode && !isNowFocusMode) {
      resetCanvas();

      // 遅延を最小限に抑えてスケルトン表示時間を短縮（以前は300ms）
      setTimeout(() => {
        store.dispatch(updateRefreshPdf(true));
      }, 50);

      const retryInterval = setInterval(() => {
        const currentState = store.getState();
        const currentToken = isRirekishoMode
          ? currentState.unifiedPdfAccessUrl.rirekisho.token
          : currentState.unifiedPdfAccessUrl.resume.token;
        const currentRefreshPdf = currentState.ui.refreshPdf;
        const currentRequesting = currentState.requesting?.requesting;

        if (currentToken && currentToken !== '') {
          clearInterval(retryInterval);
        } else if (!currentRequesting && !currentRefreshPdf) {
          store.dispatch(updateRefreshPdf(true));
        }
      }, 1000);

      setTimeout(() => {
        clearInterval(retryInterval);
      }, 10000);
    }

    prevFocusModeRef.current = isNowFocusMode;
  }, [isFocusMode, isRirekishoMode, resetCanvas]);

  /**
   * 通常モードでマウント時に最新の入力状態を確実に反映
   */
  useEffect(() => {
    const wasFocusMode = prevFocusModeRef.current;

    if (!isFocusMode && !wasFocusMode) {
      const needsRefresh = !token || token === '';

      if (needsRefresh && !isMockMode()) {
        // 遅延を最小限に抑えてスケルトン表示時間を短縮（以前は300ms）
        setTimeout(() => {
          store.dispatch(updateRefreshPdf(true));
        }, 50);
      }
    }
  }, [isFocusMode, token]);
};
